import { Length } from "@siteimprove/alfa-css";
import { None, Option } from "@siteimprove/alfa-option";
import { Media } from "./media.js";
import { Resolver } from "./resolver.js";
/**
 * {@link https://drafts.csswg.org/mediaqueries-5/#width}
 *
 * @public
 */
export class Width extends Media {
    static of(value) {
        return new Width(Option.of(value));
    }
    static _boolean = new Width(None);
    constructor(value) {
        super("width", value);
    }
    static boolean() {
        return Width._boolean;
    }
    matches(device) {
        const { viewport: { width }, } = device;
        const value = this._value.map((value) => value.map((length) => length.resolve(Resolver.length(device))));
        return width > 0
            ? value.some((value) => value.matches(Length.of(width, "px")))
            : value.every((value) => value.matches(Length.of(0, "px")));
    }
}
/**
 * @public
 */
(function (Width) {
    function from(value) {
        return value.map(Width.of).getOrElse(Width.boolean);
    }
    function isWidth(value) {
        return value instanceof Width;
    }
    Width.isWidth = isWidth;
    Width.parse = Media.parseContinuous("width", from);
})(Width || (Width = {}));
//# sourceMappingURL=width.js.map